import React from "react";
import HeaderLayout from "./header-layout";

export default class Header extends React.Component<any, {}> {
  render() {
    return <HeaderLayout />;
  }
}
